import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Typography,
    Divider,
    Box,
    IconButton,
    DialogContentText,
} from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import DeleteIcon from '@mui/icons-material/Delete';
import { updateDeviceName } from '../../api_calls/devices'; // 👈 import the API

const DeviceCardEditModal = ({ open, onClose, device, onDelete, refreshDevices }) => {
    const [name, setName] = useState(device?.name || '');
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    useEffect(() => {
        if (device?.name) setName(device.name);
        setErrorMessage('');
    }, [device]);

    const handleDeleteClick = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);
    const handleConfirmDelete = () => {
        onDelete(device);
        setConfirmOpen(false);
    };

    const handleSave = () => {
        updateDeviceName(device.id, name.trim())
            .then(() => {
                refreshDevices()
                onClose(); // ✅ close modal on success
            })
            .catch(() => {
                setErrorMessage('Failed to rename device. Please try again.');
            });
    };

    return (
        <>
            <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
                <DialogTitle>Configure {device.name}</DialogTitle>

                <DialogContent>
                    <TextField
                        label="Device Name"
                        fullWidth
                        variant="outlined"
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                            setErrorMessage('');
                        }}
                        sx={{ my: 2 }}
                        error={!!errorMessage}
                        helperText={errorMessage}
                    />

                    <Divider sx={{ mb: 2 }} />

                    <Box
                        onClick={handleDeleteClick}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2,
                            bgcolor: '#fff5f5',
                            borderRadius: 2,
                            p: 1.5,
                            cursor: 'pointer',
                            border: '1px solid #ffcdd2',
                            '&:hover': {
                                bgcolor: '#ffe5e5',
                            },
                        }}
                    >
                        <Box
                            sx={{
                                bgcolor: '#f44336',
                                color: 'white',
                                borderRadius: 2,
                                width: 40,
                                height: 40,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <DeleteIcon />
                        </Box>
                        <Box sx={{ flexGrow: 1 }}>
                            <Typography variant="subtitle1" sx={{ color: '#f44336', fontWeight: 600 }}>
                                Delete Device
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                Remove device from your house
                            </Typography>
                        </Box>
                        <IconButton size="small" edge="end">
                            <ArrowForwardIosIcon fontSize="small" sx={{ color: '#f44336' }} />
                        </IconButton>
                    </Box>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                        onClick={handleSave}
                        variant="contained"
                        disabled={!name.trim()}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Confirm Delete Dialog */}
            <Dialog open={confirmOpen} onClose={handleConfirmClose}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the device "<strong>{device.name}</strong>"?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmClose}>Cancel</Button>
                    <Button onClick={handleConfirmDelete} variant="contained" color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default DeviceCardEditModal;
